import {useTranslation} from 'react-i18next';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import {Grid} from '@mui/material';

import {EmpionButton} from '../../../../../../components/EmpionButton/EmpionButton';

interface Props {
  onDelete: () => void;
  onEdit: () => void;
  isEditing?: boolean;
}
export const CommentActions = ({onDelete, onEdit, isEditing}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'shared.formButtons'});
  const commentActionButtonSx = {
    fontSize: '15px',
    lineHeight: '22px',
    minHeight: '34px',
    px: 1.5,
    py: 0.5,
    minWidth: 'auto',
  };

  return (
    <Grid container justifyContent='flex-start' gap={1}>
      <EmpionButton onClick={onEdit} startIcon={<EditOutlinedIcon fontSize='small' />} sx={commentActionButtonSx}>
        {isEditing ? t('cancel') : t('edit')}
      </EmpionButton>

      <EmpionButton
        onClick={onDelete}
        variant='cta'
        startIcon={<DeleteOutlineIcon fontSize='small' />}
        sx={commentActionButtonSx}
      >
        {t('delete')}
      </EmpionButton>
    </Grid>
  );
};
